import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { STOMainContent } from 'modules/intelligentInsights/stoInsights/components/STOMainContent';
import { STOMainHeader } from 'modules/intelligentInsights/stoInsights/components/STOMainHeader';
import { selectIsSendTimeOptimizationInsightsFeatureFlagOn } from 'core/userContext';
import { useSTOInsightsCoreContext } from 'modules/intelligentInsights/stoInsights/contexts/CoreContext';
import { IntelligentInsightsError } from 'modules/intelligentInsights/IntelligentInsightsError';
import { FlexSpacer } from 'ui/flexSpacer';
// NEED TO DETERMINE THE CRITERIA FOR THIS
// import { IntelligentInsightsNoData } from 'modules/intelligentInsights/shared/components/IntelligentInsightsNoData';
import { IntelligentInsightsNoDataForTimeframe } from 'modules/intelligentInsights/IntelligentInsightsNoDataForTimeframe';
import { STOBackground } from 'modules/intelligentInsights/stoInsights/STO.styles';
import { IntelligentInsightsNotEnabled } from 'modules/intelligentInsights/IntelligentInsightsNotEnabled';

export const STO_INSIGHTS_FF_NOT_ENABLED_TEST_ID = 'sto-intelligent-insights-ff-not-enabled';
export const STO_INSIGHTS_ERROR_TEST_ID = 'sto-intelligent-insights-error';
export const STO_NO_DATA_FOR_TIMEFRAME_TEST_ID = 'sto-intelligent-insights-no-data-for-timeframe';
export const TBD_STO_ENABLED_NO_STO_FOR_CAMPAIGNS_TEST_ID =
  'sto-intelligent-insights-not-enabled-for-campaigns';

export const STOReporting: FC = () => {
  const { isError, isLoading, insightsErrorMessage } = useSTOInsightsCoreContext();

  const content = useMemo(() => {
    if (!isLoading) {
      if (isError) {
        if (
          insightsErrorMessage &&
          insightsErrorMessage.message?.includes('No data found for request')
        ) {
          return (
            <STOBackground>
              <FlexSpacer flexDirection="column" gap="double">
                <STOMainHeader />
                <IntelligentInsightsNoDataForTimeframe testId={STO_NO_DATA_FOR_TIMEFRAME_TEST_ID} />
              </FlexSpacer>
            </STOBackground>
          );
        }
        return <IntelligentInsightsError testId={STO_INSIGHTS_ERROR_TEST_ID} />;
      }
    }

    return <STOMainContent />;
  }, [isLoading, isError, insightsErrorMessage]);

  return content;
};

export const STOIndex: FC = () => {
  const isSTOEnabled = useSelector(selectIsSendTimeOptimizationInsightsFeatureFlagOn);

  if (!isSTOEnabled) {
    return (
      <IntelligentInsightsNotEnabled
        featureName="Send Time Optimization"
        testId={STO_INSIGHTS_FF_NOT_ENABLED_TEST_ID}
      />
    );
  }
  return <STOReporting />;
};
